export const isIdActive = (fragment: string | undefined, id: string) => {
	if (!fragment) return false

	return fragment === id || fragment.startsWith(`${id}-`)
}
